import axios from "axios"

const Documents = (idToken, url) => {
  const headers = {
    headers: {
      "Authorization": idToken
    }
  }

  return new Promise((resolve, reject) => {
    axios.get(url, headers).then(resp => {
      const { rows } = resp.data
      resolve(rows)
    }).catch(err => {
      console.error('API Error Details:', err)
      
      // Handle different error types
      if (err.response) {
        // Server responded with error status
        const status = err.response.status
        const message = err.response.data?.message || err.response.statusText

        if (status === 401) {
          reject(new Error('Authentication failed. Please log in again.'))
        } else if (status === 403) {
          reject(new Error('Permission denied. You do not have access to view this data.'))
        } else if (status === 404) {
          reject(new Error('Data not found. The requested resource does not exist.'))
        } else if (status >= 500) {
          reject(new Error('Server error. Please try again later.'))
        } else {
          reject(new Error(`Error loading data: ${message}`))
        }
      } else if (err.request) {
        // Request made but no response received
        // This can happen with CORS issues or when the server returns 401 without proper CORS headers
        // Check if the error message or status indicates authentication failure
        const errorString = err.toString().toLowerCase()
        if (errorString.includes('401') || errorString.includes('unauthorized') || errorString.includes('expired')) {
          reject(new Error('Authentication failed. Your session may have expired. Please log in again.'))
        } else {
          reject(new Error('Network error. Please check your connection and try again.'))
        }
      } else {
        // Something else happened
        reject(new Error(`Failed to load data: ${err.message}`))
      }
    })
  })
}

export default Documents